gsap.registerPlugin(ScrollTrigger);

function stdAnimation(element, duration, y){
  element.forEach((el)=> {
    gsap.from(el, {
      duration: [duration], 
      opacity: 0, 
      y: [y],
      scrollTrigger: {
        trigger: el
      }
    });
  })
}
function stdAnimationX(element, duration, x){
  element.forEach((el)=> {
    gsap.from(el, {
      duration: [duration], 
      opacity: 0, 
      x: [x],
      scrollTrigger: {
        trigger: el
      }
    });
  })
}


function staggerAnimation(element, duration, y, stagger){
  gsap.from(element, {
    duration: [duration], 
    opacity: 0, 
    y: [y],
    stagger: stagger,
    scrollTrigger: {
      trigger: [element]
    }
  });
}


// const parralax = () =>{
//   if (window.matchMedia('(max-width: 990px)').matches) {
//     if (rellax) rellax.destroy();
//   } else {
//     var rellax = new Rellax('.parrallax', {
//       center: true
//     }); 
//   }
// }
// if(!document.querySelectorAll('.header.half')[0]){
//   parralax();
// }

// window.onresize = parralax;



$(function(){
  //Heading
  if(document.getElementsByClassName('heading')[0]){
    stdAnimation(document.querySelectorAll('.heading .title'), 1, 50);
    stdAnimation(document.querySelectorAll('.heading .desc'), 1, 50);
  }
  
  //multicolumn
  if(document.getElementsByClassName('multicolumn')[0]){
    staggerAnimation(document.querySelectorAll('.l-column > .column'), .75 , 50, .25);
    stdAnimation(document.querySelectorAll('.multicolumn .l-btn'), 1, 20);
  }

  //product-teaser
  if(document.getElementsByClassName('product-teaser')[0]){
    stdAnimation(document.querySelectorAll('.product-teaser .image'), 1, 50);
    stdAnimation(document.querySelectorAll('.product-teaser .product_title'), 1, 50);
    stdAnimation(document.querySelectorAll('.product-teaser .product_price_label'), 1, 50);
    stdAnimation(document.querySelectorAll('.product-teaser .product_price'), 1, 50);
    stdAnimation(document.querySelectorAll('.product-teaser .l-btn'), 1, 50);
  }
  //product-featured
  if(document.getElementsByClassName('product-featured')[0]){
    stdAnimation(document.querySelectorAll('.product-featured .all-produtct-btn'), 1, 20);
  }

  //news-slider
  if(document.getElementsByClassName('news-slider')[0]){
    stdAnimation(document.querySelectorAll('.news-slider img'), 1, 50);
    stdAnimation(document.querySelectorAll('.news-slider h3'), 1, 20);
    stdAnimation(document.querySelectorAll('.news-slider .desc'), 1, 20);
    stdAnimation(document.querySelectorAll('.news-slider .l-btn'), 1, 20);
    stdAnimation(document.querySelectorAll('.news-slider .price'), 1, 20);
  }


  //recipe-teaser
  if(document.getElementsByClassName('recipe-teaser')[0]){
    stdAnimation(document.querySelectorAll('.recipe-teaser .image'), 1, 50);
    stdAnimation(document.querySelectorAll('.recipe-teaser .title'), 1, 50);
    stdAnimation(document.querySelectorAll('.recipe-teaser .desc'), 1, 50);
    stdAnimation(document.querySelectorAll('.recipe-teaser .l-btn'), 1, 50);
    stdAnimationX(document.querySelectorAll('.recipe-teaser:nth-child(even) .recipe_product'), 1, 500);
    stdAnimationX(document.querySelectorAll('.recipe-teaser:nth-child(odd) .recipe_product'), 1, -500);
  }

  //recipe-slider
  if(document.getElementsByClassName('recipe-slider')[0]){
    stdAnimation(document.querySelectorAll('.recipe-slider .image'), 1, 50);
    stdAnimation(document.querySelectorAll('.recipe-slider .title'), 1, 50);
    stdAnimation(document.querySelectorAll('.recipe-slider .desc'), 1, 50);
    stdAnimation(document.querySelectorAll('.recipe-slider .l-btn'), 1, 20);
    stdAnimationX(document.querySelectorAll('.recipe-slider:nth-child(odd) .recipe_product'), 1, -500);
    stdAnimation(document.querySelectorAll('.recipe-slider .all-recipe-btn'), 1, 20);
  }

  //recipe full
  if(document.getElementsByClassName('recipe_main')[0]){
    stdAnimation(document.querySelectorAll('.recipe_main .image'), 1, 50);
    stdAnimation(document.querySelectorAll('.recipe_main .content_desc'), 1, 50);
    stdAnimation(document.querySelectorAll('.recipe_main .content_ingredients'), 1, 50);
  }
  //recipe_step
  if(document.getElementsByClassName('recipe_step')[0]){
    stdAnimation(document.querySelectorAll('.recipe_step .recipe_step_content .title'), 1, 50);
    stdAnimation(document.querySelectorAll('.recipe_step .recipe_step_content .desc'), 1, 50);
    stdAnimation(document.querySelectorAll('.recipe_step .recipe_step_product'), 1, 50);
  }

  //recipe_related
  if(document.getElementsByClassName('recipe_related')[0]){
    stdAnimation(document.querySelectorAll('.recipe_related .recipe_related_block'), 1, 50);
  }


  //paragraph
  if(document.getElementsByClassName('paragraph')[0]){
    stdAnimation(document.querySelectorAll('.paragraph img'), 1, 50);
    stdAnimation(document.querySelectorAll('.paragraph .title'), 1, 50);
    stdAnimation(document.querySelectorAll('.paragraph .desc'), 1, 50);
    stdAnimation(document.querySelectorAll('.paragraph .l-btn'), 1, 50);
  }


  //page_suggestion 
  if(document.getElementsByClassName('page_suggestion')[0]){
    stdAnimation(document.querySelectorAll('.page_suggestion img'), 1, 50);
  }
  
  //cover-image
  if(document.getElementsByClassName('cover-image')[0]){
    stdAnimation(document.querySelectorAll('.cover-image .cover_content'), 1, 50);
  }


  //wall-photo-2
  if(document.getElementsByClassName('wall-photo-2')[0]){
    stdAnimationX(document.querySelectorAll('.wall-photo-2 .image_first'), 1, -50);
    stdAnimationX(document.querySelectorAll('.wall-photo-2 .image_second'), 1, 50);
  }


  //wall-photo-3
  if(document.getElementsByClassName('wall-photo-3')[0]){
    stdAnimationX(document.querySelectorAll('.wall-photo-3 .image_first'), 1, -50);
    stdAnimation(document.querySelectorAll('.wall-photo-3 .image_second'), 1, 50);
    stdAnimationX(document.querySelectorAll('.wall-photo-3 .image_third'), 1, 50);
  }

  //wall-photo-3
  if(document.getElementById('product')){
    stdAnimationX(document.querySelectorAll('.l-product h1'), 1, -50);
    stdAnimationX(document.querySelectorAll('.l-product h2'), 1, -50);
    stdAnimation(document.querySelectorAll('.l-product .desc'), 1, 50);
  }

  //product-wall
  if(document.getElementsByClassName('product-wall')[0]){
    stdAnimation(document.querySelectorAll('.product-wall .block'), 1, 50);
  }
})
